// extracted by extract-css-chunks-webpack-plugin
module.exports = {"appContainer":"App__appContainer___1ugog"};
    if(module.hot) {
      // 1778083485321
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  